import React, {FC} from "react"
import {Row, Col} from "react-bootstrap"
import {WithDefaultTheme, withTheme} from "styled-components"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import FormattedMessage from "@irati/utils/lang"
import {Body, Label} from "@irati/ui/src/Typography"
import {UnavailableCard, StyledCol} from "./styled/UnavailableDeal"

interface Props extends WithDefaultTheme {}

const UnavailableDeal: FC<Props> = ({theme}) => {
  return (
    <UnavailableCard noBorder tiny>
      <Row>
        <StyledCol xsHidden sm={2}>
          <Icon icon={IconTypes.circleDisable} size={25} color={theme.colors.utility.ink} />
        </StyledCol>
        <Col xs={12} sm={10}>
          <Label large weight="bold">
            <FormattedMessage id="perks.components.dealInfoBlock.unavailableDeal.header" />
          </Label>
          <Body small margin={[1, 0, 0]}>
            <FormattedMessage id="perks.components.dealInfoBlock.unavailableDeal.text" />
          </Body>
        </Col>
      </Row>
    </UnavailableCard>
  )
}

export default withTheme(UnavailableDeal)
